<div id="dashboard" [class.is-opened]="isNavbarOpenedObservable | async">
  <div class="left-nav">
    <app-side-nav></app-side-nav>
  </div>
  <div class="right-container">
    <router-outlet></router-outlet>
  </div>
</div>